// extracted by mini-css-extract-plugin
export var text = "_35-0";